import apiClient, { extractData } from "./client";

export async function listAgendaEmployees() {
  const response = await apiClient.get("/agenda/employees");
  return extractData(response);
}

export async function getMyAgenda() {
  const response = await apiClient.get("/agenda/me");
  return extractData(response);
}

export async function getEmployeeAgenda(employeeId, params = {}) {
  const response = await apiClient.get(`/agenda/employees/${employeeId}`, {
    params,
  });
  return extractData(response);
}

export async function createAgendaNote(data) {
  const response = await apiClient.post("/agenda", data);
  return extractData(response);
}

export async function updateAgendaNote(id, data) {
  const response = await apiClient.patch(`/agenda/${id}`, data);
  return extractData(response);
}

export async function deleteAgendaNote(id) {
  const response = await apiClient.delete(`/agenda/${id}`);
  return extractData(response);
}
